module.exports = __webpack_public_path__ + "static/media/improve.5515da3e.svg";